import { CODES } from '../config/apiErrorCodes';
import { toast } from "react-toastify";
import {AES, enc}from 'crypto-js';
//import store here
import {store} from '../../redux/_helpers/store';
import 'react-toastify/dist/ReactToastify.css';
import {successLoader,} from '../../redux/_actions/loader.action';
import Cookies from 'cookies-js';
toast.configure()

async function requestTimeout(ms, controller) {
    return new Promise(resolve => {
        setTimeout(function () {
            console.log('5 seconds done', controller)
            controller.abort();
        }, ms);
    });
}
// let isTokenAvailable ='';
// const refreshToken =  sessionStorage.getItem("isAuthenticated")
// if(refreshToken != null){
// const decrypted = AES.decrypt(refreshToken, 'itsEncrypted');
// const decryptedObject = decrypted.toString(enc.Utf8);
// const getRefreshToken = JSON.parse(decryptedObject)
//  isTokenAvailable = JSON.stringify(getRefreshToken);
// }

export const uploadApiCall = async (method = 'GET', link, body, headers, showToast= true, isUpload = false) => {
   
const isTokenAvailable =await sessionStorage.getItem("Decrypted Token")
    const tokenDetails = JSON.parse(isTokenAvailable);
    let testAccess = Cookies.get('msAL_admin_dev');
    testAccess= JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
    //testAccess= (AES.decrypt(testAccess, 'itsEncrypted'))
//true
   store.dispatch(successLoader(false));
    const controller = new AbortController();
    const signal = controller.signal;
    requestTimeout(11000, controller);
    let obj = {
        method: method,
        // headers:{ ...headers, authorization: 'Bearer'+` ${testAccess}` },
        headers:{ 'x-cc-trace-id' :"xyz", authorization: 'Bearer'+` ${testAccess}`},
        signal: controller.signal
    };
    
if (method=="PUT" || method=="POST" || method=="DELETE" )obj.body = isUpload?body:JSON.stringify(body)
    console.log(body,JSON.stringify(body));
    return await fetch(link, obj)
        .then((data) => {
            // false
            store.dispatch(successLoader(true));
            return data;
        })
        .then((data) => {
            if (data.status == '200') {
                return data.json().then(d => d);
                // return data.then(d=>d);
            }
            else if (data.status == '500') {
                let status = data.status;
                return data.json().then(d => { return { data: d, flag: status } });
            }
            throw { statusCode: data.status };
        })
        .then((data) => {
            return data;
        })
        .catch((err) => { 
            // false
            store.dispatch(successLoader(true));
            if(err.statusCode){
                let code = err.statusCode;
                err = Object.keys(CODES).includes("" + code)?`${code}, ${CODES[code]}`:err;
            }
            let toastMessage = (err.name === 'AbortError') ? 'Request Timeout' : 'Something went wrong!';
            if(showToast){
                toast(toastMessage ,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}});
        }
            console.warn('inside catch', err); 
            return { errorMessage: err, flag: -1 }
        })
}

